// Centralized site constants for Kakkanat Postnatal Care
export const WHATSAPP_NUMBER = "919061622255";

export const WHATSAPP_MESSAGES = {
  default:
    "Hello Kakkanat, I'd like to enquire about villa availability for postnatal care. Could you please share more details?",
  availability:
    "Hello Kakkanat, I'd like to check villa availability and possible dates for postnatal care. Could you guide me?",
  book:
    "Hello Kakkanat, I'd like to book a private villa for postnatal care. Please share next steps.",
  pricing:
    "Hello Kakkanat, I have a few questions about your postnatal care packages and pricing.",
};

export const buildWhatsAppLink = (key = "default") => {
  const msg = WHATSAPP_MESSAGES[key] || WHATSAPP_MESSAGES.default;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
};

export const SITE = {
  brand: "Kakkanat",
  brandFull: "Kakkanat Postnatal Care",
  tagline: "Prasava Raksha, Authentic Ayurvedic Postnatal Care",
  address: "Paruthipra, Shoranur, Palakkad, Kerala",
  whatsappDisplay: "+91 90616 22255",
  logoLight:
    "https://customer-assets.emergentagent.com/job_kakkanat-postnatal/artifacts/6uoc26v4_ka_1080_e_v2_logo_1.png",
  logoDark:
    "https://customer-assets.emergentagent.com/job_kakkanat-postnatal/artifacts/ui93yjbj_ka_1080_e_v2_logo_3.png",
};

export const IMAGES = {
  hero:
    "https://customer-assets.emergentagent.com/job_kakkanat-postnatal/artifacts/adqplqa3_ChatGPT%20Image%20May%205%2C%202026%20at%2002_09_11%20PM.png",
  villaExterior:
    "https://images.unsplash.com/photo-1677559401235-fe6d5ba9a4df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxheXVydmVkYSUyMHNwYSUyMGtlcmFsYXxlbnwwfHx8fDE3Nzc5NjkzNTF8MA&ixlib=rb-4.1.0&q=85",
  villaInterior:
    "https://customer-assets.emergentagent.com/job_kakkanat-postnatal/artifacts/qr3ibwwj_ChatGPT%20Image%20May%205%2C%202026%20at%2003_39_34%20PM.png",
  founder:
    "https://customer-assets.emergentagent.com/job_kakkanat-postnatal/artifacts/q8cjgk6o_IMG_7236.jpeg",
  ayurvedaKit:
    "https://customer-assets.emergentagent.com/job_kakkanat-postnatal/artifacts/59pyd0sv_ChatGPT%20Image%20May%2026%2C%202026%20at%2008_12_16%20AM.png",
  villaBedroom:
    "https://customer-assets.emergentagent.com/job_kakkanat-postnatal/artifacts/jyc1s39e_Bedroom.jpg",
  villaHall:
    "https://customer-assets.emergentagent.com/job_kakkanat-postnatal/artifacts/lsoqgevb_Hall.jpg",
  villaKitchen:
    "https://customer-assets.emergentagent.com/job_kakkanat-postnatal/artifacts/3dy0c4hg_Kitchen.jpg",
  villaOutside:
    "https://customer-assets.emergentagent.com/job_kakkanat-postnatal/artifacts/kya6zlu0_Outside.jpg",
};
